<template>
  <div class="col-lg-12   text-center bg-gray border shadow  py-3 rounded-5">
    <slot><h3>سایت ویرا یدک</h3></slot>
    <div class="screen">
      <img class="img-thumbnail img-sizing "
           @mouseover="mouseOverImage()"
           @mouseleave="mouseLeaveImage()"
           :class="hashGenerator"
           :src="image" :alt="alt">
    </div>
  </div>
</template>

<script>
import mImg from "../Tags/Img";
import {CardProps} from "../Cards/CardProps";
import mA from "../Tags/A";
import {generateHash} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/ShoppingCart";


export default {
  name: "Card500.vue",
  components: {
    mA,
    mImg,
  },
  props: {
    ...CardProps,
  },
  computed: {
    hashGenerator() {
      return 'scroll-manager-' + generateHash()
    }
  },
  methods: {

  },

  mounted() {


  }
}


</script>

<style scoped>
.rounded-5 {
  border-radius: 25px;
}

.img-sizing {
  height: auto;
  position: absolute;
  z-index: 0;
  left: 0;
  right: 0;
  margin: auto;
  padding: 0;
  transition: bottom 3s ease-in-out;
}

.screen {
  height: 300px;
  display: block;
  overflow: hidden;
  position: relative;
  margin: 0 auto;
  z-index: 1;
}

.hash {


}


</style>